var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"draggable-dlg",style:(_vm._f("toCss")(_vm.draggedPos)),on:{"mousedown":function($event){return _vm.startDrag($event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }